import React from 'react'
import { DefaultDataTable } from '../../../components/dataTable/DefaultDataTable'

export const CrudDinamicoDefinicaoList = (props) => <DefaultDataTable data={props} />
